import Integrations from 'shared/components/Integrations';

export const IntegrationsSettings = () => <Integrations />;
